import BaseModel from './BaseModel'
import {makeObservable, observable} from 'mobx'

export default class TeamQuery extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      parent_id: observable,
      company_id: observable
    })
  }
  parent_id = null;
  company_id = null;
}